import { ICommandShortcutHandler, ICommandShortcutContext, IChatWindowCommandShortcutContext } from '@/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service-interface';
import { getCommandMatches } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/helper';

class ToggleUserListSortOrderCommandShortcutHandler implements ICommandShortcutHandler {
  private readonly commandMatchRegularExpressions = [/^\/sort$/i];

  public canProcessCommand(command: string, context: ICommandShortcutContext): boolean {
    const chatWindowContext = context as IChatWindowCommandShortcutContext;
    if (chatWindowContext && typeof chatWindowContext.toggleUserListSortOrder === 'function') {
      const commandMatches = getCommandMatches(command, this.commandMatchRegularExpressions);
      return commandMatches && commandMatches.length === 1;
    }
    return false;
  }

  public processCommand(command: string, context: ICommandShortcutContext): void {
    if (this.canProcessCommand(command, context)) {
      const chatWindowContext = context as IChatWindowCommandShortcutContext;
      setImmediate(() => chatWindowContext.toggleUserListSortOrder());
    }
  }
}

export { ToggleUserListSortOrderCommandShortcutHandler };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/handlers/toggle-user-list-sort-order.ts